var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"TopicInfoDialog_main"}},[_c('el-dialog',{attrs:{"title":"議案說明","visible":_vm.dialogVisible,"width":"40%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"info"},[_vm._v("\n      "+_vm._s(_vm.data)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }